import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { PPL_DIALOG_DATA } from '@ppl/ui/dialog';
import { of } from 'rxjs';
import type { Observable } from 'rxjs';

@Component({
    selector: 'ppl-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    styleUrls: ['./loading-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingDialogComponent {

  text$: Observable<string> = this.data.text$ || of(null);

  constructor(
    @Inject(PPL_DIALOG_DATA) public data: LoadingDialogData
  ) { }

}

export interface LoadingDialogData {
  hideLoading?: boolean
  text$?: Observable<string>;
}
